import mutations from "./mutations";
import * as actions from "./actions";
import * as getters from "./getters";

// state
let state = {
    adminData: null,
    regimenData:null,
    editUserId: null,
    roles: null,
    getUser: null,
    notesData: null,
    insightData: null
}

export default {mutations, actions, state, getters}


// WEBPACK FOOTER //
// ./src/store/modules/admin/index.js